import { Flex } from '@chakra-ui/react';
import Card from 'components/card/Card';


export default function PlatformStats() {
	return (
		<Flex direction='column' pt={{ sm: '125px', lg: '75px' }}>
			<Card px='0px'>
				Platform stats placeholder
			</Card>
		</Flex>
	);
}
